import { Pane } from "tweakpane";

export class UIManager {
    static editPane: any = null;
}